import RouteChangeTracker from "./RouteChangeTracker";

const AppLayout = ({ children }) => {
  RouteChangeTracker();

  return <>{children}</>;
};

export default AppLayout;
